import Vue from 'vue';

// fontawesome svg
import { library } from "@fortawesome/fontawesome-svg-core";
import { faBars, faTimes, faSpinner, faHome, faUserFriends, faInfo, faAddressCard, faUserTie, faHandPaper, faQuestion, faTrashAlt, faCog, faEdit, faChevronDown, faChevronUp, faCaretUp, faSignOutAlt, faChevronRight, faChevronLeft, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faBars, faTimes, faSpinner, faHome, faUserFriends, faInfo, faAddressCard, faUserTie, faHandPaper, faQuestion, faTrashAlt, faCog, faEdit, faChevronDown, faChevronUp, faCaretUp, faSignOutAlt, faChevronRight, faChevronLeft, faPlusCircle);
Vue.component('font-awesome-icon', FontAwesomeIcon);